import { SchemaRecord } from "../SchemaRecord.js";

export class MeshStatusParams extends SchemaRecord {
  static type = "chat.params.mesh_status";
  static schema = {};
}
